import { createSlice } from '@reduxjs/toolkit';

import type { OnboardingData } from './types';

const initialState: OnboardingData = {
    currentOnboardingSteps: [
        {
            id: 'firstName',
            isValid: false,
            status: 'inProgress'
        },
        {
            id: 'lastName',
            isValid: false,
            status: 'pending'
        },
        {
            id: 'phone',
            isValid: false,
            status: 'pending'
        },
        {
            id: 'organization',
            isValid: false,
            status: 'pending'
        }
    ]
};

export const slice = createSlice({
    initialState,

    name: 'onboardingData',

    reducers: {
        currentOnboardingSteps: (state, action) => {
            state.currentOnboardingSteps = action.payload;
        }
    }
});

export default slice.reducer;
